module.exports = __webpack_public_path__ + "static/media/seasonal_page_Q4_2025_continuum_btn.aa53d006.png";